var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.448 8A3.449 3.449 0 1 1 4.55 8a3.449 3.449 0 0 1 6.898 0zm4.333-.796c-2.108-2.742-4.635-4.131-7.511-4.131h-.541c-2.932 0-5.46 1.352-7.511 4.019-.29.394-.29 1.009 0 1.401.121.157.257.322.391.486v.007h.005c1.482 1.82 3.744 3.942 7.115 3.942h.541c3.744 0 6.079-2.477 7.511-4.339a1.201 1.201 0 0 0 0-1.385z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.724 8c0-.951-.774-1.725-1.725-1.725S6.275 7.049 6.275 8c0 .951.773 1.725 1.724 1.725S9.724 8.951 9.724 8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPassword);
export default __webpack_public_path__ + "static/media/show_password.cfc894d0412790b2ba9a52c8451826a7.svg";
export { ForwardRef as ReactComponent };